import React from "react";
import { getValue } from "@utils/lodash";

function LegalDetailsSvgComponent(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
        <defs>
            <clipPath id="clip-path-legal-details">
            <rect id="Rectangle_18145" data-name="Rectangle 18145" width="18" height="18" transform="translate(-12042 -7150)" fill="#fff"/>
            </clipPath>
        </defs>
        <g id="Group_10471" data-name="Group 10471" transform="translate(-159 -209)">
            <g id="Group_10459" data-name="Group 10459" transform="translate(12235 7200)">
            <circle id="Ellipse_3667" data-name="Ellipse 3667" cx="16" cy="16" r="16" transform="translate(-12076 -6991)" fill="#f3e8fc"/>
            <g id="Mask_Group_255" data-name="Mask Group 255" transform="translate(-27 166)" clip-path="url(#clip-path-legal-details)">
                <path id="gavel_FILL0_wght300_GRAD0_opsz24" d="M4.015-4.716v-1.36h10.4v1.36ZM9.263-9.394l-4.8-4.81L6.053-15.84l4.841,4.81L9.263-9.394Zm5.359-5.376-4.8-4.856,1.631-1.591,4.8,4.81Zm4.35,9.059L7.485-17.232l.953-.956L19.925-6.666Z" transform="translate(-12044.97 -7128.034)" fill="#8339cb"/>
            </g>
            </g>
        </g>
        </svg>
  );
}

export default LegalDetailsSvgComponent;
